import { ReactNode } from 'react';
import { Button, Modal } from 'react-bootstrap';

type ConfirmationModalProps = {
  show: boolean;
  title: ReactNode;
  onHide: () => void;
  onConfirm: () => void;
  children: ReactNode;
  confirmLabel?: ReactNode;
  confirmDisabled?: boolean;
};

const ConfirmationModal = ({ show, title, onHide, onConfirm, children, confirmLabel = 'Conferma', confirmDisabled = false }: ConfirmationModalProps) => (
  <Modal className="tootor-modal" show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      <Button variant="primary" className="tootor-button tootor-button--secondary" disabled={confirmDisabled} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export { ConfirmationModal };
